export default {
  methods: {
    iniciarInteracao () {
      this.handleTyping('digitando...');

      window.axios.post('/chatbot/iniciar-interacao', {
        token: this.$store.state.token,
        origem: this.$store.state.origem
      }).then(response => {
        this.$store.commit('updateConversaToken', response.data.conversa_token);
        this.$store.commit('updateProximoFluxoInteracaoToken', response.data.primeiro_fluxo_interacao_token);
        this.interacaoSupport();
      });
    },
    interacaoSupport () {
      if (this.$store.state.proximoFluxoInteracaoToken === null) {
        return;
      }

      this.handleTyping('digitando...');

      window.axios.post('/chatbot/interacao', {
        autor: 'support',
        conversa_token: this.$store.state.conversaToken,
        fluxo_interacao_token: this.$store.state.proximoFluxoInteracaoToken
      }).then(response => {
        this.handleTyping('');

        this.$store.commit('updateFluxoToken', response.data.fluxo_token);

        if (response.data.gtm_event) {
          window.EventBus.$emit('SEND_GTM_EVENT', response.data.gtm_event);
        }

        // Tipos de Interação
        if (response.data.tipo_interacao === 'text') {
          this.onMessageWasSent({
            author: 'support',
            type: 'text',
            data: { text: response.data.interacao, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'buttons') {
          this.onMessageWasSent({
            author: 'support',
            type: 'buttons',
            data: { text: response.data.interacao, options: response.data.opcoes, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'choice') {
          this.onMessageWasSent({
            author: 'support',
            type: 'choice',
            data: { text: response.data.interacao, options: response.data.opcoes },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'choice_ajax') {
          this.onMessageWasSent({
            author: 'support',
            type: 'choice_ajax',
            data: { text: response.data.interacao, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'multiple_selections') {
          this.onMessageWasSent({
            author: 'support',
            type: 'multiple_selections',
            data: { text: response.data.interacao, options: response.data.opcoes, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'life_insurance_calculations') {
          this.onMessageWasSent({
            author: 'support',
            type: 'life_insurance_calculations',
            data: { text: response.data.interacao, options: response.data.opcoes, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'personal_accident_insurance_calculations') {
          this.onMessageWasSent({
            author: 'support',
            type: 'personal_accident_insurance_calculations',
            data: { text: response.data.interacao, options: response.data.opcoes, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'income_loss_insurance_calculation') {
          this.onMessageWasSent({
            author: 'support',
            type: 'income_loss_insurance_calculation',
            data: { text: response.data.interacao, options: response.data.opcoes, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'professional_protection_insurance_calculations') {
          this.onMessageWasSent({
            author: 'support',
            type: 'professional_protection_insurance_calculations',
            data: { text: response.data.interacao, options: response.data.opcoes, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'vehicle_insurance_calculations') {
          this.onMessageWasSent({
            author: 'support',
            type: 'vehicle_insurance_calculations',
            data: { text: response.data.interacao, options: response.data.opcoes },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'vehicle_insurance_calculations2') {
          this.onMessageWasSent({
            author: 'support',
            type: 'vehicle_insurance_calculations2',
            data: { text: response.data.interacao },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'vehicle_insurance_calculations_with_adjust_coverage') {
          this.onMessageWasSent({
            author: 'support',
            type: 'vehicle_insurance_calculations_with_adjust_coverage',
            data: { text: response.data.interacao },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'residential_insurance_calculations') {
          this.onMessageWasSent({
            author: 'support',
            type: 'residential_insurance_calculations',
            data: { text: response.data.interacao },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'funeral') {
          this.onMessageWasSent({
            author: 'support',
            type: 'funeral',
            data: { text: response.data.interacao, options: response.data.opcoes },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'assists') {
          this.onMessageWasSent({
            author: 'support',
            type: 'assists',
            data: { text: response.data.interacao, options: response.data.opcoes },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'values') {
          this.onMessageWasSent({
            author: 'support',
            type: 'values',
            data: { text: response.data.interacao, options: response.data.opcoes },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'whatsapp') {
          this.onMessageWasSent({
            author: 'support',
            type: 'whatsapp',
            data: { text: response.data.interacao, options: response.data.opcoes, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'table') {
          this.onMessageWasSent({
            author: 'support',
            type: 'table',
            data: { text: response.data.interacao, options: response.data.opcoes, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'html') {
          this.onMessageWasSent({
            author: 'support',
            type: 'html',
            data: { text: response.data.interacao, options: response.data.opcoes, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'life_insurance_calculations_infocap') {
          this.onMessageWasSent({
            author: 'support',
            type: 'life_insurance_calculations_infocap',
            data: { text: response.data.interacao },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'residential_insurance_calculations_infocap') {
          this.onMessageWasSent({
            author: 'support',
            type: 'residential_insurance_calculations_infocap',
            data: { text: response.data.interacao },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'vehicle_insurance_calculations_infocap') {
          this.onMessageWasSent({
            author: 'support',
            type: 'vehicle_insurance_calculations_infocap',
            data: { text: response.data.interacao },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'age_ranges_approvita') {
          this.onMessageWasSent({
            author: 'support',
            type: 'age_ranges_approvita',
            data: { text: response.data.interacao, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'health_plan_calculations_approvita') {
          this.onMessageWasSent({
            author: 'support',
            type: 'health_plan_calculations_approvita',
            data: { text: response.data.interacao, options: response.data.opcoes },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'odontology_plan_calculations_approvita') {
          this.onMessageWasSent({
            author: 'support',
            type: 'odontology_plan_calculations_approvita',
            data: { text: response.data.interacao, options: response.data.opcoes },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'health_plan_calculations_simplemed') {
          this.onMessageWasSent({
            author: 'support',
            type: 'health_plan_calculations_simplemed',
            data: { text: response.data.interacao, options: response.data.opcoes },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'bike_insurance_calculations_gente_seguradora') {
          this.onMessageWasSent({
            author: 'support',
            type: 'bike_insurance_calculations_gente_seguradora',
            data: { text: response.data.interacao, options: response.data.opcoes },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'insurance_calculations_yupin') {
          this.onMessageWasSent({
            author: 'support',
            type: 'insurance_calculations_yupin',
            data: { text: response.data.interacao, options: response.data.opcoes },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'certificate_yupin') {
          this.onMessageWasSent({
            author: 'support',
            type: 'certificate_yupin',
            data: { text: response.data.interacao, options: response.data.opcoes, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'vehicle_insurance_calculations_suhai') {
          this.onMessageWasSent({
            author: 'support',
            type: 'vehicle_insurance_calculations_suhai',
            data: { text: response.data.interacao, options: response.data.opcoes },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'saluap_life_insurance_calculations') {
          this.onMessageWasSent({
            author: 'support',
            type: 'saluap_life_insurance_calculations',
            data: { text: response.data.interacao, options: response.data.opcoes, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'saluap_personal_accident_insurance_calculations') {
          this.onMessageWasSent({
            author: 'support',
            type: 'saluap_personal_accident_insurance_calculations',
            data: { text: response.data.interacao, options: response.data.opcoes, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'age_ranges_roselife') {
          this.onMessageWasSent({
            author: 'support',
            type: 'age_ranges_roselife',
            data: { text: response.data.interacao },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'health_plan_calculations_roselife') {
          this.onMessageWasSent({
            author: 'support',
            type: 'health_plan_calculations_roselife',
            data: { text: response.data.interacao, options: response.data.opcoes },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'insurance_calculations_argo_rc_advogados_pf_yupin') {
          this.onMessageWasSent({
            author: 'support',
            type: 'insurance_calculations_argo_rc_advogados_pf_yupin',
            data: { text: response.data.interacao, options: response.data.opcoes },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'insurance_calculations_eqseguros_yupin') {
          this.onMessageWasSent({
            author: 'support',
            type: 'insurance_calculations_eqseguros_yupin',
            data: { text: response.data.interacao, options: response.data.opcoes },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'insurance_calculations_fianca') {
          this.onMessageWasSent({
            author: 'support',
            type: 'insurance_calculations_fianca',
            data: { text: response.data.interacao },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'age_ranges_hapvida_rv') {
          this.onMessageWasSent({
            author: 'support',
            type: 'age_ranges_hapvida_rv',
            data: { text: response.data.interacao, metadata: response.data.metadata },
            automatic_answer: response.data.resposta_automatica || false
          });
        } else if (response.data.tipo_interacao === 'health_plan_calculations_hapvida_rv') {
          this.onMessageWasSent({
            author: 'support',
            type: 'health_plan_calculations_hapvida_rv',
            data: { text: response.data.interacao, options: response.data.opcoes },
            automatic_answer: response.data.resposta_automatica || false
          });
        }

        // Tipos de Resposta
        if (response.data.tipo_resposta === 'none') {
          this.$store.commit('updateProximoFluxoInteracaoToken', response.data.proximo_fluxo_interacao_token);
          this.$store.commit('updateRespostaPadrao', null);
          this.interacaoSupport();
        } else {
          this.$store.commit('updateProximoFluxoInteracaoToken', response.data.fluxo_interacao_token);
          this.$store.commit('updateEditarFluxoInteracaoToken', response.data.fluxo_interacao_token);
          this.$store.commit('updateRespostaName', response.data.resposta_name);
          this.$store.commit('updateRespostaPadrao', response.data.resposta_padrao);
          this.$store.commit('updateRespostaAutomatica', response.data.resposta_automatica);

          if (response.data.tipo_resposta === 'text') {
            this.$store.commit('updateActiveUserInteraction', true);
            this.$store.commit('updateActiveUserInteractionInputType', 'text');
            this.$store.commit('updateRespostaPlaceholder', response.data.resposta_placeholder);
            this.$store.commit('updateRespostaMask', response.data.resposta_mask);
            this.$store.commit('updateRespostaRegex', response.data.resposta_regex);

            setTimeout(() => {
              window.EventBus.$emit('FOCUS_USER_INPUT');
            }, 100);
          }

          if (response.data.tipo_resposta === 'valor_moeda_real') {
            this.$store.commit('updateActiveUserInteraction', true);
            this.$store.commit('updateActiveUserInteractionInputType', 'valor_moeda_real');

            setTimeout(() => {
              window.EventBus.$emit('FOCUS_USER_INPUT');
            }, 100);
          }
        }
      });
    },
    interacaoMe (payload) {
      window.axios.post('/chatbot/interacao', {
        autor: 'me',
        conversa_token: this.$store.state.conversaToken,
        fluxo_interacao_token: this.$store.state.proximoFluxoInteracaoToken,
        resposta_key: payload.data.key || null,
        resposta_value: payload.data.text,
        resposta_metadata: payload.data.metadata || null,
        resposta_automatica: this.$store.state.respostaAutomatica
      }).then(response => {
        if (response.data.gtm_event) {
          window.EventBus.$emit('SEND_GTM_EVENT', response.data.gtm_event);
        }

        if (payload.data.restart) {
          window.EventBus.$emit('RESTART_CHAT');
          return;
        }

        if (payload.data.finish) {
          window.EventBus.$emit('CLOSE_CHAT');
          window.EventBus.$emit('FINISHED_CHAT');
          return;
        }

        if (response.data.validacao) {
          this.handleTyping('digitando...');

          setTimeout(() => {
            this.onMessageWasSent({
              author: 'support',
              type: 'text',
              data: { text: response.data.validacao, metadata: response.data.metadata },
              automatic_answer: response.data.resposta_automatica || false
            });

            this.handleTyping('');

            this.$store.commit('updateActiveUserInteraction', true);

            setTimeout(() => {
              window.EventBus.$emit('FOCUS_USER_INPUT');
            }, 100);
          }, 800);

          return;
        }

        this.$store.commit('updateProximoFluxoInteracaoToken', response.data.proximo_fluxo_interacao_token);
        this.interacaoSupport();
      });
    },
  }
}
